import { ChartOfAccountsRow } from "@common/helpers/domains/accounting/buildHierarchicalChartOfAccounts";
import { CoaMappingPreviewSource } from "./buildCoaMappingPreview";

export function findFirstMappedAccountId({
    rows,
    sourcesByAccountId,
}: {
    rows: ChartOfAccountsRow[];
    sourcesByAccountId: ReadonlyMap<string, CoaMappingPreviewSource[]>;
}): string | null {
    for (const row of rows) {
        if (row.account && sourcesByAccountId.has(row.account.id)) {
            return row.account.id;
        }
        const nestedAccountId = row.accounts
            ? findFirstMappedAccountId({
                  rows: row.accounts,
                  sourcesByAccountId,
              })
            : null;
        if (nestedAccountId !== null) {
            return nestedAccountId;
        }
    }
    return null;
}
